import { FOfferType } from '../../../packages/JsonQuery';
import { IOfferTypeSelectOptionsGroup } from '../components/OfferTypeSelect';

export const getDailyRentOfferTypes = (isHotelsEnabled: boolean): IOfferTypeSelectOptionsGroup[] =>
  [
    {
      label: 'Квартиры и комнаты',
      options: [
        { label: 'Квартира', value: FOfferType.Flat },
        { label: 'Комната', value: FOfferType.Room },
        { label: 'Койко-место', value: FOfferType.Bed },
      ],
    },
    {
      label: 'Дома и участки',
      options: [{ label: 'Дом, дача', value: FOfferType.House }],
    },
    isHotelsEnabled && {
      label: 'Отели и гостиницы',
      options: [{ label: 'Отели', value: FOfferType.Hotel }],
    },
  ].filter(Boolean) as IOfferTypeSelectOptionsGroup[];
